// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2YGaJ","label":"Completed_label__Ris9j"};